import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SnackbarOrigin} from "@mui/material/Snackbar";
import {AlertProps} from "@mui/material/Alert";

export interface SnackbarState {
    action: boolean;
    open: boolean;
    message: string;
    anchorOrigin: SnackbarOrigin;
    variant: string;
    alert: AlertProps;
    transition: string;
    close: boolean;
    actionButton: boolean;
    dense: boolean;
    maxStack: number;
    iconVariant: string;
}

const initialState: SnackbarState = {
    action: false,
    open: false,
    message: 'Note archived',
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
    },
    variant: 'default',
    alert: {
        color: 'primary',
        variant: 'filled'
    },
    transition: 'Fade',
    close: false,
    actionButton: false,
    maxStack: 3,
    dense: false,
    iconVariant: 'usedefault'
};

export const snackBarSlice = createSlice({
    name: "snackbar",
    initialState,
    reducers: {
        openSnackbar: (state, snackbarAction: PayloadAction<SnackbarState>) => {
            const {
                action,
                open,
                message,
                anchorOrigin,
                variant,
                alert,
                transition,
                close,
                actionButton
            } = snackbarAction.payload;

            state.action = action || initialState.action
            state.open = open || initialState.open
            state.message = message || initialState.message
            state.anchorOrigin = anchorOrigin || initialState.anchorOrigin
            state.variant = variant || initialState.variant
            state.alert = {
                color: alert?.color || initialState.alert.color,
                variant: alert?.variant || initialState.alert.variant
            }
            state.transition = transition || initialState.transition
            state.close = close || initialState.close
            state.actionButton = actionButton || initialState.actionButton
        },
        closeSnackbar: (state) => {
            state.open = false
        },
        handlerIncrease: (state, action: PayloadAction<number>) => {
            state.maxStack = action.payload
        },
        handlerDense: (state, action: PayloadAction<boolean>) => {
            state.dense = action.payload
        },
        handlerIconVariants: (state, action: PayloadAction<string>) => {
            state.iconVariant = action.payload
        }
    }
})

export const {
    openSnackbar,
    closeSnackbar,
    handlerIncrease,
    handlerDense,
    handlerIconVariants
} = snackBarSlice.actions

export default snackBarSlice.reducer